var map = {
	"./aspire.png": 2360,
	"./eis.png": 8973,
	"./manchester.png": 468,
	"./manoor.png": 7566,
	"./mils.png": 2691,
	"./nces.png": 1351,
	"./nnhis.png": 4628,
	"./noor.png": 0
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;